'use client'

import { useFlow } from '@/shared/lib/steps-flow'
import { AdminAutoCompleteButton } from '@/shared/ui/AdminAutoCompleteButton'

import { useLevelContext } from '../contexts/LevelContext'

import { LevelHeartsAndCountdown } from './HeartsAndCountdown'

export const LevelToolbar = () => {
  const { state } = useFlow()
  const { level } = useLevelContext()
  const { currentIndex } = state

  return (
    <div className="flex items-center justify-between w-full gap-6 pb-6">
      <div className="relative w-full bg-white rounded-lg">
        <div className="p-2 rounded-full bg-jacaranda/20 h-[36px]">
          <div
            className="h-[21px] bg-tie rounded-full transition-[width] duration-200 ease-in-out"
            style={{
              width: `${Math.min(
                (Math.max(currentIndex - 1, 0) / state.steps.length) * 100 + 10,
                100
              )}%`
            }}
          />
        </div>
      </div>
      <div className="flex items-center justify-end gap-2 w-125px">
        {/* Conclui o nível inteiro sem responder desafio a desafio — o suporte
            atravessa o que não interessa e para onde o aluno travou. */}
        {level?.id ? (
          <AdminAutoCompleteButton type="Level" id={level.id} label="Concluir" />
        ) : null}
        <LevelHeartsAndCountdown />
      </div>
    </div>
  )
}
